import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import "./StudentLoanDebtSection.css";

const BALANCE_RANGES = [
  ["zero", "$0", "No student loans"],
  ["up_to_10000", "Up to $10,000", "More than $0"],
  ["10001_to_20000", "$10,001–$20,000", "Outstanding balance"],
  ["20001_to_30000", "$20,001–$30,000", "Outstanding balance"],
  ["over_30000", "Over $30,000", "More than $30,000"],
];

export default function StudentLoanDebtSection() {
  const { values, setValues, setFieldValue, handleBlur, errors, touched } = useFormikContext();
  const balanceRange = values.studentLoanBalanceRange || 'zero';
  const age = values.studentLoanAge ?? '';
  const hasStudentLoans = balanceRange !== "" && balanceRange !== "zero";

  return (
    <section className="cc-debt-card cc-student-loan" aria-labelledby="student-loan-heading">
      <header className="cc-debt-card__header">
        <h6 id="student-loan-heading">C - Student <span>Loan</span></h6>
        <p>Tell us your total outstanding student loan balance, including federal and private loans.</p>
      </header>
      <fieldset className="cc-student-loan__ranges" aria-required="true" aria-describedby="student-loan-hint">
        <legend>How much do you owe in student loans? <span className="cc-student-loan__required">Required</span></legend>
        <p id="student-loan-hint">Choose one range. If you have no student loans, select $0.</p>
        <div className="cc-student-loan__options">
          {BALANCE_RANGES.map(([value, label, hint]) => (
            <label key={value} className={`cc-student-loan__option${balanceRange === value ? " is-selected" : ""}`}>
              <input type="radio" name="studentLoanBalanceRange" value={value} checked={balanceRange === value} aria-invalid={Boolean(touched.studentLoanBalanceRange && errors.studentLoanBalanceRange)} aria-describedby="student-loan-range-error" onBlur={handleBlur} onChange={() => {
                setValues(current => ({ ...current, studentLoanBalanceRange: value, studentLoanAge: value === 'zero' ? '' : current.studentLoanAge }), true);
              }} />
              <span><strong>{label}</strong><small>{hint}</small></span>
            </label>
          ))}
        </div>
        <ErrorMessage id="student-loan-range-error" name="studentLoanBalanceRange" component="div" className="cc-student-loan__error" />
      </fieldset>
      {hasStudentLoans && (
        <div className="cc-student-loan__age input_wrap">
          <label className="label-title" htmlFor="student-loan-age">Current age</label>
          <p id="student-loan-age-hint">Enter your age in years.</p>
          <input id="student-loan-age" name="studentLoanAge" type="number" min="1" max="120" step="1" inputMode="numeric" className={`form-control${touched.studentLoanAge && errors.studentLoanAge ? ' is-invalid' : ''}`} placeholder="e.g. 32" value={age} onBlur={handleBlur} onChange={(event) => setFieldValue('studentLoanAge', event.target.value)} aria-invalid={Boolean(touched.studentLoanAge && errors.studentLoanAge)} aria-describedby="student-loan-age-hint student-loan-age-error" />
          <ErrorMessage id="student-loan-age-error" name="studentLoanAge" component="div" className="cc-student-loan__error" />
        </div>
      )}
    </section>
  );
}
